const spacing = {}
export default spacing;
